import React from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

const arr = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5+' }
];

export const CharacteristicsFilter = ({
  filtersAndSort,
  setFiltersAndSort,
  name,
  label
}) => (
  <>
    <Form.Group>
      <Form.Label>{label}</Form.Label>

      <div className="w-100 d-flex justify-content-around">
        {arr.map((item, index) => (
          <div key={index} className="text-center">
            <Form.Check
              className="m-0"
              type="radio"
              checked={filtersAndSort[name].includes(item.value)}
              onChange={() => {}}
              onClick={() => {
                let newFilters = [...filtersAndSort[name]];

                if (filtersAndSort[name].includes(item.value)) {
                  newFilters = newFilters.filter(
                    filter => filter !== item.value
                  );
                } else {
                  newFilters.push(item.value);
                }

                setFiltersAndSort({
                  ...filtersAndSort,
                  [name]: newFilters
                });
              }}
            />

            <label className="m-0">{item.label}</label>
          </div>
        ))}
      </div>
    </Form.Group>
  </>
);
CharacteristicsFilter.propTypes = {
  filtersAndSort: PropTypes.object.isRequired,
  setFiltersAndSort: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  singular: PropTypes.string.isRequired,
  plural: PropTypes.string.isRequired
};
